import { Controller } from "@hotwired/stimulus";
import StimulusReflex from "stimulus_reflex";

// Typeahead for the partner API OAuth consent picker. Writes the chosen winery's
// id into the hidden `organization_id` field the consent form submits; the
// server re-validates it (PartnerConsentEligibility) so this is UX only.
export default class extends Controller {
  static targets = ["input", "results", "selectedId"];

  connect() {
    StimulusReflex.register(this);
  }

  // Reveal the server-seeded initial list when the field is focused, so staff
  // can browse without typing. Hidden again on blur (deferred so a result click
  // registers first).
  showResults() {
    if (this.resultsTarget.querySelector("[data-organization-id]")) {
      this.resultsTarget.classList.remove("hidden");
    }
  }

  hideResults() {
    setTimeout(() => this.resultsTarget.classList.add("hidden"), 150);
  }

  search() {
    const query = this.inputTarget.value.trim();
    if (query.length < 2) {
      this.resultsTarget.classList.add("hidden");
      return;
    }

    this.element.dataset.query = query;

    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => {
      this.stimulate("PartnerConsentOrganizationSearch#search");
    }, 200);
  }

  beforeSearch() {
    this.resultsTarget.classList.add("opacity-50");
  }

  searchSuccess() {
    this.resultsTarget.classList.remove("opacity-50");
    this.resultsTarget.classList.remove("hidden");
  }

  searchError() {
    this.resultsTarget.classList.remove("opacity-50");
    this.resultsTarget.classList.add("hidden");
  }

  select(event) {
    this.selectedIdTarget.value = event.currentTarget.dataset.organizationId;
    this.inputTarget.value = event.currentTarget.dataset.organizationName;
    this.resultsTarget.classList.add("hidden");
    this.selectedIdTarget.dispatchEvent(new Event("change", { bubbles: true }));
  }

  // Clear a stale selection as soon as the user edits the text, so the form
  // can't submit an organization_id that no longer matches the visible name.
  inputChanged() {
    if (this.selectedIdTarget.value) {
      this.selectedIdTarget.value = "";
    }
  }
}
